import { Component, OnInit, EventEmitter, Output, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BrandLogo } from './brand-logo.model';
import { UploadPictureComponent } from '../shared/upload-picture.component';
import { FormHelperService } from '../core/services/form-helper.service';
import { BrandLogosService } from './brand-logos.service';
import { FilterService } from '../core/services/filter.service';
import { DropdownValue } from '../shared/dropdown.model';
import { BrandModel } from '../shared/brand.model';

@Component({
  moduleId: module.id,
  selector: 'brand-logo-modal',
  templateUrl: 'brand-logo-modal.component.html'
})

export class BrandLogoModalComponent implements OnInit {
  brandIdField: number;
  brandLogoForm: FormGroup;
  headerText: string = "Create Brand Logo";
  showDuplicateError: boolean = false;
  isLoading = false;
  private readonly modalId = "#brandLogoModal";
  showUploadError: boolean = false;

  selectedBrand: any;
  brandsList: Array<BrandModel> = [];
  brandId?: number;
  showBrandOverlay: boolean = false;

  @Output() brandLogoCreated: EventEmitter<any> = new EventEmitter<Event>();;

  @ViewChild("uploadPicture") uploadPicture: UploadPictureComponent

  constructor(private formBuilder: FormBuilder,
    private formHelperService: FormHelperService,
    private brandLogoService: BrandLogosService,
    private filterItemsService: FilterService,
    private el: ElementRef) {
  }

  ngOnInit() {
    this.brandsList = this.filterItemsService.getBrands();

    this.brandLogoForm = this.formBuilder.group({
      brandIdField: ['', [Validators.required]],
      picture: ['', [Validators.required]]
    });
  }

  onSaveChanges(event: any) {
    if (!this.brandLogoForm.valid)
      return;
    this.isLoading = true;
    let selectedBrandId = this.brandId;
    let self = this;
    let reader = new FileReader();
    reader.onload = (function (theFile) {
      return function (e) {
        let binaryString = e.target.result;
        self.brandLogoService.createBrandLogo(selectedBrandId, binaryString.replace(/^data:image\/[a-z]+;base64,/, ""), null)
          .subscribe(() => {
            self.brandLogoCreated.emit();
            $(self.modalId).modal('hide');
          }, (error: any) => { this.isLoading = false; }, () => { self.isLoading = false; });
      };
    })(this.uploadPicture.file);

    reader.readAsDataURL(this.uploadPicture.file);
  }

  showCreateBrandLogo() {
    this.isLoading = false;
    this.headerText = "Create Brand Logo";
    this.brandLogoForm.reset();
    if (this.uploadPicture)
      this.uploadPicture.reset();
    this.showUploadError = false;
    $(this.modalId).modal('show');
  }

  showErrorMessage(controlName: string, validator: string): boolean {
    return this.formHelperService.showErrorMessage(this.brandLogoForm, controlName, validator);
  }

  onUploadChanged(name: any): void {
    this.brandLogoForm.controls["picture"].setValue(name);
    if (name)
      this.showUploadError = false;
    else
      this.showUploadError = true;
  }

  onBrandAutocompleteClicked(item) {
    let ng2Autocomplete = this.el.nativeElement.querySelectorAll("ng2-auto-complete");
    $(ng2Autocomplete).addClass('custom-autocomplete');
    //remove the selection from the previous brand and select the current brand
    let listOfBrands = $(ng2Autocomplete).find('ul li');
    let brand = this.selectedBrand;
    $(listOfBrands).each(function (i, e) {
      $(e).removeClass('selected');
      if (brand == $(e).text()) $(e).addClass('selected');
    });
  }

  onBrandValueChanged(item) {
    this.brandId = item.id;
  }

  autocompleListFormatter(data: any): string {
    return `${data.name}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/brand-logos/brand-logo-modal.component.ts